export const customTableStyles = {
  rows: {
    style: {
      // minHeight: "72px", // override the row height
      // "&:hover": {
      //   backgroundColor: "#e6d9ff",
      //   cursor: "pointer",
      // },
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px", // override the cell padding for head cells
      paddingRight: "8px",
      paddingTop: "8px", // override the cell padding for data cells
      paddingBottom: "8px",
      // textTransform: "uppercase",
      fontWeight: "600",
      fontSize: "14px",
      // letterSpacing: "-0.02em",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px", // override the cell padding for data cells
      paddingRight: "8px",
      paddingTop: "8px", // override the cell padding for data cells
      paddingBottom: "8px",
    },
  },
};

export const highlightRowStyle = (highlightedRow) => [
  {
    when: (row) => row.id === highlightedRow,
    style: {
      backgroundColor: "#e3f2fd",
      borderLeft: "4px solid #2196f3",
    },
  },
];
